var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkLightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 12 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3915 0.906491L10.508 0.0224915L4.32052 6.20949L1.49202 3.38099L0.608521 4.26499L4.32052 7.97749L11.3915 0.906491Z",
    fill: "#066FEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkLightBlue);
export default __webpack_public_path__ + "static/media/checkmark-light-blue.0bbfa2442c4ca9bedd34281dec7a6e29.svg";
export { ForwardRef as ReactComponent };